export const initAppendHiddenInputsToPlanForms = () => {
    // VARS
    const priceForms = document.querySelectorAll('[data-price-form]');
    const dataUrl = sessionStorage.getItem('url');

    if (!document.querySelector('[data-plan-form-url]')) {
        return;
    }

    const planUrl = document.querySelector('[data-plan-form-url]').dataset.planFormUrl;

    // INITS
    if (dataUrl) {
        appendHiddenInputsToForms();
    }

    // FUNCTIONS
    function appendHiddenInputsToForms() {
        const searchParams = new URLSearchParams(dataUrl);

        [...priceForms].forEach((form) => {
            // exception for form https://umobix.com/ru/gps-cell-phone-locator.html
            for (const searchParam of searchParams) {
                if (
                    (searchParam[0] === 'utm_medium' ||
                        searchParam[0] === 'utm_source' ||
                        searchParam[0] === 'utm_campaign') &&
                    planUrl.includes('utm_source=umobixRUbanner')
                ) {
                    return;
                }

                form.append(createHiddenInput(searchParam));
            }
        });
    }
};

export function createHiddenInput([name, value]) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;

    return input;
}
